import React from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";

import CustomTab from "../Common/CustomTab";

import { eventGroups, allEvents } from "../../constants/common";

import colors from "../../assets/style/colors";

const styles = {
  container: {
    height: "50px",
    width: "100%",
    backgroundColor: colors.white,
    paddingLeft: "24px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  tabs: {
    height: "50px",
    float: "left",
    minHeight: "50px",
  },
};

const EventsTopBar = (props) => {
  const { classes, section } = props;

  return (
    <Grid container className={classes.container}>
      <Tabs
        value={section}
        onChange={(e, value) => props.history.push(`/events/${value}`)}
        indicatorColor="primary"
        centered
        className={classes.tabs}
      >
        <CustomTab
          height="50px"
          label={I18n.get("events_eventGroups")}
          value={eventGroups}
        />
        <CustomTab
          height="50px"
          label={I18n.get("events_allEvents")}
          value={allEvents}
        />
      </Tabs>
    </Grid>
  );
};

export default withStyles(styles)(withRouter(EventsTopBar));
